import { render, staticRenderFns } from "./IconfontComponent.vue?vue&type=template&id=128a7e3a&scoped=true&"
import script from "./IconfontComponent.vue?vue&type=script&lang=js&"
export * from "./IconfontComponent.vue?vue&type=script&lang=js&"
import style0 from "./IconfontComponent.vue?vue&type=style&index=0&id=128a7e3a&lang=scss&scoped=true&"
import style1 from "./IconfontComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128a7e3a",
  null
  
)

export default component.exports